










































































































import { Component, Vue } from "vue-property-decorator";
import { formatList } from "@/utils/i18n";
import InstanceContactLink from "@/components/About/InstanceContactLink.vue";
import { LANGUAGES_CODES } from "@/graphql/admin";
import { ILanguage } from "@/types/admin.model";
import { ABOUT } from "../../graphql/config";
import { STATISTICS } from "../../graphql/statistics";
import { IConfig } from "../../types/config.model";
import { IStatistics } from "../../types/statistics.model";

@Component({
  apollo: {
    config: ABOUT,
    statistics: STATISTICS,
    languages: {
      query: LANGUAGES_CODES,
      variables() {
        return {
          codes: this?.config.languages,
        };
      },
      skip() {
        return !this.config || !this.config?.languages;
      },
    },
  },
  components: {
    InstanceContactLink,
  },
  metaInfo() {
    return {
      title: this.$t("About {instance}", {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        instance: this?.config?.name,
      }) as string,
    };
  },
})
export default class AboutInstance extends Vue {
  config!: IConfig;

  statistics!: IStatistics;

  languages!: ILanguage[];

  get formattedLanguageList(): string {
    if (this.languages) {
      const list = this.languages.map(({ name }) => name);
      return formatList(list);
    }
    return "";
  }
}
